import { create } from 'zustand';
import { authApi } from './api';
import { setOnForcedLogout, tokenStore } from './apiClient';
import type { User } from './types';

interface AuthState {
  user: User | null;
  isInitialized: boolean;
  isLoading: boolean;
  initialize: () => Promise<void>;
  login: (email: string, password: string) => Promise<User>;
  logout: () => Promise<void>;
  setUser: (user: User | null) => void;
}

export const useAuthStore = create<AuthState>((set) => {
  setOnForcedLogout(() => set({ user: null }));

  return {
    user: null,
    isInitialized: false,
    isLoading: false,

    async initialize() {
      const access = tokenStore.getAccess();
      if (!access) {
        set({ isInitialized: true });
        return;
      }
      try {
        const { user } = await authApi.me();
        set({ user, isInitialized: true });
      } catch {
        tokenStore.clear();
        set({ user: null, isInitialized: true });
      }
    },

    async login(email, password) {
      set({ isLoading: true });
      try {
        const resp = await authApi.login(email, password);
        tokenStore.save({ access: resp.access_token, refresh: resp.refresh_token });
        set({ user: resp.user, isLoading: false });
        return resp.user;
      } catch (e) {
        set({ isLoading: false });
        throw e;
      }
    },

    async logout() {
      await authApi.logout();
      tokenStore.clear();
      set({ user: null });
    },

    setUser: (user) => set({ user }),
  };
});
